// LOCAL
export const config = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  BASE_PHARMACY_URL: process.env.REACT_APP_BASE_PHARMACY_URL,
  BASE_UNIVERSITY_URL: process.env.REACT_APP_BASE_UNIVERSITY_URL,
  BASE_CHAT_URL: process.env.REACT_APP_BASE_CHAT_URL,
  BASE_PORTAL_URL: process.env.REACT_APP_BASE_PORTAL_URL,
  ONLY_ALLOW_CHROME: process.env.REACT_APP_ONLY_CHROME === 'true' ? true : false
};



// WEBPACK FOOTER //
// ./src/config.ts